// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__Pve7Q","isOpen":"Sidebar_isOpen__2CEBM","CloseButton":"Sidebar_CloseButton__1j3dp","VisibilityButton":"Sidebar_VisibilityButton__PJTRv"};